import { SettlementsService } from '../../services/settlements.service';

export const SETTLEMENTS_ACTION_TYPES = {
  LOAD_SETTLEMENTS_REQUEST: 'LOAD_SETTLEMENTS_REQUEST',
  LOAD_SETTLEMENTS_SUCCESS: 'LOAD_SETTLEMENTS_SUCCESS',
  LOAD_SETTLEMENTS_FAILURE: 'LOAD_SETTLEMENTS_FAILURE'
};

export const loadSettlements = () => async (dispatch, getState) => {
  const { settlementsApp } = getState();
  
  // If we already have settlements, don't fetch again
  if (settlementsApp && settlementsApp.settlements && settlementsApp.settlements.length > 0) {
    return;
  }
  
  if (settlementsApp.loading) {
    return;
  }

  dispatch({ type: SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_REQUEST });

  try {
    const data = await SettlementsService.getSettlements();
    dispatch({
      type: SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_FAILURE,
      payload: error.message || 'Failed to load settlements'
    });
  }
};
